import { Party } from '../types';

export type RecipientOption = {
  id: string;
  value: string;
  name: string;
  address: string;
  emailKind: string;
  roles: string[];
};

export const buildRecipientOptions = (parties: Party[]): RecipientOption[] =>
  parties.flatMap((party) =>
    (party.emails ?? []).map((email) => ({
      id: email._id || `${party._id}-${email.address}`,
      value: `${party.name} <${email.address}>`,
      name: party.name,
      address: email.address,
      emailKind: email.kind,
      roles: party.kinds ?? [],
    }))
  );

export const matchesRecipient = (option: RecipientOption, query: string): boolean => {
  const tokens = query.trim().toLowerCase().split(/\s+/).filter(Boolean);
  if (tokens.length === 0) return true;
  const haystack = [option.name, option.address, option.emailKind, ...option.roles]
    .filter(Boolean)
    .join(' ')
    .toLowerCase();
  return tokens.every((token) => haystack.includes(token));
};
